import api from './api';

const baseUrl = '/admin/commissions';

const buildQuery = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '' || value === 'all') return;
    query.append(key, value);
  });

  return query.toString();
};

const unwrap = (response) => response?.data?.data || response?.data || {};

const adminCommissionService = {
  async getInvoices(params = {}) {
    const query = buildQuery(params);
    const response = await api.get(`${baseUrl}/invoices${query ? `?${query}` : ''}`);
    return unwrap(response);
  },

  async getInvoiceDetails(invoiceId) {
    const response = await api.get(`${baseUrl}/invoices/${invoiceId}`);
    return unwrap(response);
  },

  async downloadInvoicePdf(invoiceId) {
    const response = await api.get(`${baseUrl}/invoices/${invoiceId}/pdf`, {
      responseType: 'blob',
      timeout: 60000
    });

    if (!response.data || response.data.size === 0) {
      throw new Error('Aucune donnée PDF reçue du serveur');
    }

    return response.data;
  },

  async searchOwners(query = '') {
    const path = query && query.trim().length >= 2
      ? `/admin/users/search?query=${encodeURIComponent(query.trim())}`
      : '/admin/users';
    const response = await api.get(path);
    const data = unwrap(response);
    return data?.users || [];
  },

  async generate(payload = {}) {
    const response = await api.post(`${baseUrl}/generate`, payload);
    return unwrap(response);
  },

  async sendPaymentRequests(invoiceIds = []) {
    const response = await api.post(`${baseUrl}/send-payment-requests`, {
      invoice_ids: invoiceIds
    });
    return unwrap(response);
  },

  async updateInvoiceStatus(invoiceId, payload) {
    const response = await api.put(`${baseUrl}/invoices/${invoiceId}/status`, payload);
    return unwrap(response);
  },

  async getStats(period = '') {
    const query = buildQuery({ period });
    const response = await api.get(`${baseUrl}/stats${query ? `?${query}` : ''}`);
    return unwrap(response);
  },

  async getCronStatus() {
    const response = await api.get(`${baseUrl}/cron/status`);
    return unwrap(response);
  },

  async runCron(options = {}) {
    const response = await api.post(`${baseUrl}/cron/run`, { options });
    return unwrap(response);
  }
};

export default adminCommissionService;